import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

const SOCIALS = [
  { name: "Instagram", href: "https://instagram.com/zatayoo", Icon: Instagram, handle: "@zatayoo" },
  { name: "Facebook", href: "https://facebook.com/zatayoo.india", Icon: Facebook, handle: "zatayoo.india" },
];

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-primary/10 bg-secondary/40 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center w-9 h-9 rounded-full bg-primary text-primary-foreground font-display text-lg leading-none">z</span>
            <span className="font-display text-2xl text-foreground">zatayoo</span>
          </div>
          <p className="text-muted-foreground max-w-sm leading-relaxed">
            Hidden places, soulful treks and secret coastlines — plus flights, hotels, buses and cabs to get you there. Travel off the beaten path.
          </p>
          <p className="mt-4 font-display text-lg text-foreground">Dare To Rise <span className="text-accent">— bringing technology to travel.</span></p>
          <Link to="/about" className="inline-block mt-2 text-sm text-accent font-semibold hover:underline">Our story →</Link>

          <div className="mt-6">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground/70 mb-3">Follow us</h4>
            <div className="flex items-center gap-3">
              {SOCIALS.map(({ name, href, Icon, handle }) => (
                <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={name} title={`${name} · ${handle}`}
                  data-testid={`social-${name.toLowerCase()}`}
                  className="group inline-flex items-center gap-2 rounded-full border border-primary/20 bg-card px-4 py-2 text-sm font-medium text-foreground/80 hover:text-accent-foreground hover:bg-accent hover:border-accent transition-colors">
                  <Icon size={18} className="shrink-0" />
                  <span className="hidden sm:inline">{handle}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground/70 mb-4">Discover</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/explore" className="hover:text-accent transition-colors">All experiences</Link></li>
            <li><Link to="/explore?category=treks" className="hover:text-accent transition-colors">Treks & trails</Link></li>
            <li><Link to="/explore?category=hidden-party" className="hover:text-accent transition-colors">Hidden parties</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground/70 mb-4">Book</h4>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/flights" className="hover:text-accent transition-colors">Flights</Link></li>
            <li><Link to="/hotels" className="hover:text-accent transition-colors">Hotels</Link></li>
            <li><a href="mailto:hello@zatayoo.com" className="hover:text-accent transition-colors">hello@zatayoo.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} Zatayoo. Travel differently.</span>
          <div className="flex items-center gap-3">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={name}
                data-testid={`social-bottom-${name.toLowerCase()}`}
                className="grid place-items-center w-9 h-9 rounded-full border border-primary/15 text-foreground/70 hover:text-accent-foreground hover:bg-accent hover:border-accent transition-colors">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
